import { axiosClient as axios } from './axiosClient';

import {
  CategoryResultViewModel,
  CategorySelectOptionResultViewModel,
  CategoryTableResultViewModel,
  CategoryViewModel,
} from '@models/Category';
import {
  failureResult,
  ResultViewModel,
  successResult,
} from '@models/common/ResultViewModel';
import { handleAxiosError } from '@utils/axiosErrorHandler';
import { getDataUrl } from '@utils/dataUrls';
import { api } from 'src/config/apiEndpoints';

export const CategoryService = {
  create: async function (
    category: CategoryViewModel
  ): Promise<CategoryResultViewModel | ResultViewModel> {
    const createUrl = `${api.BASE_URL}${api.CATEGORIES_ENDPOINT}`;
    try {
      const response = await axios.post(createUrl, category);
      return response.data as CategoryResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getList: async function (
    page?: number,
    pageSize?: number,
    searchFields?: string,
    search?: string,
    filters?: string,
    sortBy?: string,
    sortDirection?: string
  ): Promise<CategoryTableResultViewModel | ResultViewModel> {
    let dataUrl = getDataUrl(
      api.BASE_URL,
      api.CATEGORIES_ENDPOINT,
      page,
      pageSize,
      searchFields,
      search,
      sortBy,
      sortDirection
    );

    if (filters) {
      dataUrl = dataUrl + filters;
    }

    try {
      const response = await axios.get(dataUrl);
      return response.data as CategoryTableResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getById: async function (
    id: number
  ): Promise<CategoryResultViewModel | ResultViewModel> {
    const dataUrl = `${api.BASE_URL}${api.CATEGORIES_ENDPOINT}/${id}`;

    try {
      const response = await axios.get(dataUrl);
      return response.data as CategoryResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getCategorySelectOptions: async function (): Promise<
    CategorySelectOptionResultViewModel | ResultViewModel
  > {
    const dataUrl = `${api.BASE_URL}${api.CATEGORIES_ENDPOINT}/select-options`;
    try {
      const response = await axios.get(dataUrl);
      return response.data as CategorySelectOptionResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getParentCategorySelectOptions: async function (
    id: number
  ): Promise<CategorySelectOptionResultViewModel | ResultViewModel> {
    const dataUrl = `${api.BASE_URL}${api.CATEGORIES_ENDPOINT}/parent-category-select-options?id=${id}`;

    try {
      const response = await axios.get(dataUrl);
      return response.data as CategorySelectOptionResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  update: async function (
    id: number,
    category: CategoryViewModel
  ): Promise<ResultViewModel> {
    const updateUrl = `${api.BASE_URL}${api.CATEGORIES_ENDPOINT}/${id}`;

    try {
      const response = await axios.put(updateUrl, category);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  delete: async function (id: number): Promise<ResultViewModel> {
    const deleteURL = `${api.BASE_URL}${api.CATEGORIES_ENDPOINT}/${id}`;

    try {
      const response = await axios.delete(deleteURL);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
};
